export const LOCAL_GALLERY_PHOTOS = [
  {
    "id": "img-1",
    "title": "Sri Gnana Sai Baba Sanctum Darshan",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba1.jpg",
    "url": "/images/gallery/saibaba1.jpg",
    "altText": "Sri Gnana Sai Baba Sanctum Darshan",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-2",
    "title": "Sri Gnana Sai Baba Golden Alankaram",
    "category": "alankaram",
    "displayCategory": "Divine Alankaram",
    "src": "/images/gallery/saibaba2.jpg",
    "url": "/images/gallery/saibaba2.jpg",
    "altText": "Sri Gnana Sai Baba Golden Alankaram",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-3",
    "title": "Sri Gnana Sai Baba Divine Grace",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba3.jpg",
    "url": "/images/gallery/saibaba3.jpg",
    "altText": "Sri Gnana Sai Baba Divine Grace",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-4",
    "title": "Sri Gnana Sai Baba Maha Deeparadhana",
    "category": "poojas",
    "displayCategory": "Aarti & Poojas",
    "src": "/images/gallery/saibaba4.jpg",
    "url": "/images/gallery/saibaba4.jpg",
    "altText": "Sri Gnana Sai Baba Maha Deeparadhana",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-5",
    "title": "Sri Gnana Sai Baba Pushpa Alankaram",
    "category": "alankaram",
    "displayCategory": "Divine Alankaram",
    "src": "/images/gallery/saibaba5.jpg",
    "url": "/images/gallery/saibaba5.jpg",
    "altText": "Sri Gnana Sai Baba Pushpa Alankaram",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-6",
    "title": "Sri Gnana Sai Baba Sanctum Peedam",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba6.jpg",
    "url": "/images/gallery/saibaba6.jpg",
    "altText": "Sri Gnana Sai Baba Sanctum Peedam",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-7",
    "title": "Sri Gnana Sai Baba Abhishekam Blessings",
    "category": "poojas",
    "displayCategory": "Aarti & Poojas",
    "src": "/images/gallery/saibaba7.jpg",
    "url": "/images/gallery/saibaba7.jpg",
    "altText": "Sri Gnana Sai Baba Abhishekam Blessings",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-8",
    "title": "Sri Gnana Sai Baba Rajatha Simhasanam",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba8.jpg",
    "url": "/images/gallery/saibaba8.jpg",
    "altText": "Sri Gnana Sai Baba Rajatha Simhasanam",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-9",
    "title": "Sri Gnana Sai Baba Divine Murti",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba9.jpg",
    "url": "/images/gallery/saibaba9.jpg",
    "altText": "Sri Gnana Sai Baba Divine Murti",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-10",
    "title": "Sri Gnana Sai Baba Navarathri Alankaram",
    "category": "alankaram",
    "displayCategory": "Divine Alankaram",
    "src": "/images/gallery/saibaba10.jpg",
    "url": "/images/gallery/saibaba10.jpg",
    "altText": "Sri Gnana Sai Baba Navarathri Alankaram",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-11",
    "title": "Sri Gnana Sai Baba Vastra Samarpanam",
    "category": "alankaram",
    "displayCategory": "Divine Alankaram",
    "src": "/images/gallery/saibaba11.jpg",
    "url": "/images/gallery/saibaba11.jpg",
    "altText": "Sri Gnana Sai Baba Vastra Samarpanam",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-12",
    "title": "Sri Sai Baba Mangala Aarti",
    "category": "poojas",
    "displayCategory": "Aarti & Poojas",
    "src": "/images/gallery/saibaba12.jpg",
    "url": "/images/gallery/saibaba12.jpg",
    "altText": "Sri Sai Baba Mangala Aarti",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-13",
    "title": "Sri Gnana Sai Baba Special Alankaram",
    "category": "alankaram",
    "displayCategory": "Divine Alankaram",
    "src": "/images/gallery/saibaba13.jpg",
    "url": "/images/gallery/saibaba13.jpg",
    "altText": "Sri Gnana Sai Baba Special Alankaram",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-14",
    "title": "Sri Gnana Sai Baba Sacred Archana",
    "category": "poojas",
    "displayCategory": "Aarti & Poojas",
    "src": "/images/gallery/saibaba14.jpg",
    "url": "/images/gallery/saibaba14.jpg",
    "altText": "Sri Gnana Sai Baba Sacred Archana",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-15",
    "title": "Sri Gnana Sai Baba Sanctum Darshan",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba15.jpg",
    "url": "/images/gallery/saibaba15.jpg",
    "altText": "Sri Gnana Sai Baba Sanctum Darshan",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-16",
    "title": "Sri Gnana Sai Baba Sanctum Grace",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba16.jpg",
    "url": "/images/gallery/saibaba16.jpg",
    "altText": "Sri Gnana Sai Baba Sanctum Grace",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-17",
    "title": "Special Amavasya Pooja & Homam",
    "category": "poojas",
    "displayCategory": "Aarti & Poojas",
    "src": "/images/gallery/saibaba17.jpg",
    "url": "/images/gallery/saibaba17.jpg",
    "altText": "Special Amavasya Pooja & Homam",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-18",
    "title": "Sri Gnana Sai Baba Divine Glance",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba18.jpg",
    "url": "/images/gallery/saibaba18.jpg",
    "altText": "Sri Gnana Sai Baba Divine Glance",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-19",
    "title": "Sri Gnana Sai Baba Guru Pournami Alankaram",
    "category": "alankaram",
    "displayCategory": "Divine Alankaram",
    "src": "/images/gallery/saibaba19.jpg",
    "url": "/images/gallery/saibaba19.jpg",
    "altText": "Sri Gnana Sai Baba Guru Pournami Alankaram",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-20",
    "title": "Sri Gnana Sai Baba Sanctum Darshan",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba20.jpg",
    "url": "/images/gallery/saibaba20.jpg",
    "altText": "Sri Gnana Sai Baba Sanctum Darshan",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-21",
    "title": "Kamadhenu Gomata Darshan",
    "category": "seva",
    "displayCategory": "Seva & Annadhanam",
    "src": "/images/gallery/saibaba21.jpg",
    "url": "/images/gallery/saibaba21.jpg",
    "altText": "Kamadhenu Gomata Darshan",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-22",
    "title": "Sri Gnana Sai Baba Sanctum Blessings",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba22.jpg",
    "url": "/images/gallery/saibaba22.jpg",
    "altText": "Sri Gnana Sai Baba Sanctum Blessings",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-23",
    "title": "Sri Gnana Sai Baba Divine Aura",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba23.jpg",
    "url": "/images/gallery/saibaba23.jpg",
    "altText": "Sri Gnana Sai Baba Divine Aura",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-24",
    "title": "Sri Gnana Sai Baba Sacred Darshan",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba24.jpg",
    "url": "/images/gallery/saibaba24.jpg",
    "altText": "Sri Gnana Sai Baba Sacred Darshan",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-25",
    "title": "Sri Gnana Sai Baba Thursday Special Alankaram",
    "category": "alankaram",
    "displayCategory": "Divine Alankaram",
    "src": "/images/gallery/saibaba25.jpg",
    "url": "/images/gallery/saibaba25.jpg",
    "altText": "Sri Gnana Sai Baba Thursday Special Alankaram",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-26",
    "title": "Sri Gnana Sai Baba Sanctum Darshan",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba26.jpg",
    "url": "/images/gallery/saibaba26.jpg",
    "altText": "Sri Gnana Sai Baba Sanctum Darshan",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-27",
    "title": "Sri Gnana Sai Baba Divine Presence",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba27.jpg",
    "url": "/images/gallery/saibaba27.jpg",
    "altText": "Sri Gnana Sai Baba Divine Presence",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-28",
    "title": "Sri Gnana Sai Baba Raja Alankaram",
    "category": "alankaram",
    "displayCategory": "Divine Alankaram",
    "src": "/images/gallery/saibaba28.jpg",
    "url": "/images/gallery/saibaba28.jpg",
    "altText": "Sri Gnana Sai Baba Raja Alankaram",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-29",
    "title": "Sri Gnana Sai Baba Sanctum Darshan",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba29.jpg",
    "url": "/images/gallery/saibaba29.jpg",
    "altText": "Sri Gnana Sai Baba Sanctum Darshan",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-30",
    "title": "Sri Gnana Sai Baba Divine Compassion",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba30.jpg",
    "url": "/images/gallery/saibaba30.jpg",
    "altText": "Sri Gnana Sai Baba Divine Compassion",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-31",
    "title": "Sri Gnana Sai Baba Pushpa Pallakku Alankaram",
    "category": "alankaram",
    "displayCategory": "Divine Alankaram",
    "src": "/images/gallery/saibaba31.jpg",
    "url": "/images/gallery/saibaba31.jpg",
    "altText": "Sri Gnana Sai Baba Pushpa Pallakku Alankaram",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-32",
    "title": "Sri Gnana Sai Baba Sanctum Darshan",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba32.jpg",
    "url": "/images/gallery/saibaba32.jpg",
    "altText": "Sri Gnana Sai Baba Sanctum Darshan",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-33",
    "title": "Sri Gnana Sai Baba Sacred Darshan",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba33.jpg",
    "url": "/images/gallery/saibaba33.jpg",
    "altText": "Sri Gnana Sai Baba Sacred Darshan",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-34",
    "title": "Sri Gnana Sai Baba Sanctum Darshan",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba34.jpg",
    "url": "/images/gallery/saibaba34.jpg",
    "altText": "Sri Gnana Sai Baba Sanctum Darshan",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-35",
    "title": "Sri Gnana Sai Baba Divine Darshan",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba35.jpg",
    "url": "/images/gallery/saibaba35.jpg",
    "altText": "Sri Gnana Sai Baba Divine Darshan",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-36",
    "title": "Maha Annadhanam Seva",
    "category": "seva",
    "displayCategory": "Seva & Annadhanam",
    "src": "/images/gallery/saibaba36.jpg",
    "url": "/images/gallery/saibaba36.jpg",
    "altText": "Maha Annadhanam Seva",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-37",
    "title": "Sri Gnana Sai Baba Swarna Kavacham",
    "category": "alankaram",
    "displayCategory": "Divine Alankaram",
    "src": "/images/gallery/saibaba37.jpg",
    "url": "/images/gallery/saibaba37.jpg",
    "altText": "Sri Gnana Sai Baba Swarna Kavacham",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-38",
    "title": "Sri Gnana Sai Baba Sanctum Darshan",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba38.jpg",
    "url": "/images/gallery/saibaba38.jpg",
    "altText": "Sri Gnana Sai Baba Sanctum Darshan",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-39",
    "title": "Sri Gnana Sai Baba Maha Mangala Aarti",
    "category": "poojas",
    "displayCategory": "Aarti & Poojas",
    "src": "/images/gallery/saibaba39.jpg",
    "url": "/images/gallery/saibaba39.jpg",
    "altText": "Sri Gnana Sai Baba Maha Mangala Aarti",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-40",
    "title": "Sri Gnana Sai Baba Sanctum Darshan",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba40.jpg",
    "url": "/images/gallery/saibaba40.jpg",
    "altText": "Sri Gnana Sai Baba Sanctum Darshan",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-41",
    "title": "Sacred Ashtothara Archana",
    "category": "poojas",
    "displayCategory": "Aarti & Poojas",
    "src": "/images/gallery/saibaba41.jpg",
    "url": "/images/gallery/saibaba41.jpg",
    "altText": "Sacred Ashtothara Archana",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-42",
    "title": "Sri Gnana Sai Baba Sanctum Darshan 44",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/gallery/saibaba44.jpg",
    "url": "/images/gallery/saibaba44.jpg",
    "altText": "Sri Gnana Sai Baba Sanctum Darshan 44",
    "caption": "Divine Darshan of Sri Gnana Sai Baba Mandir, Ambattur"
  },
  {
    "id": "img-43",
    "title": "Guruji Sri Gnana Sai Baba Mandir",
    "category": "guruji",
    "displayCategory": "Guruji",
    "src": "/images/guruji.jpg",
    "url": "/images/guruji.jpg",
    "altText": "Guruji Sri Gnana Sai Baba Mandir",
    "caption": "Spiritual guide and Yagna Acharya at Sri Gnana Sai Baba Mandir"
  },
  {
    "id": "img-44",
    "title": "Mandir Founder",
    "category": "guruji",
    "displayCategory": "Guruji",
    "src": "/images/Founder.jpg",
    "url": "/images/Founder.jpg",
    "altText": "Mandir Founder",
    "caption": "Founder of Sri Gnana Sai Baba Mandir Sanctum"
  },
  {
    "id": "img-45",
    "title": "Mandir Co-Founder",
    "category": "guruji",
    "displayCategory": "Guruji",
    "src": "/images/co-founder.jpg",
    "url": "/images/co-founder.jpg",
    "altText": "Mandir Co-Founder",
    "caption": "Co-Founder of Sri Gnana Sai Baba Mandir"
  },
  {
    "id": "img-46",
    "title": "Sacred Akhanda Sai Dhuni",
    "category": "poojas",
    "displayCategory": "Aarti & Poojas",
    "src": "/images/dhuni.jpg",
    "url": "/images/dhuni.jpg",
    "altText": "Sacred Akhanda Sai Dhuni",
    "caption": "Continuous sacred fire lit with divine reverence"
  },
  {
    "id": "img-47",
    "title": "Sacred Gho Pooja",
    "category": "poojas",
    "displayCategory": "Aarti & Poojas",
    "src": "/images/gho-pooja.jpg",
    "url": "/images/gho-pooja.jpg",
    "altText": "Sacred Gho Pooja",
    "caption": "Worship of sacred Gomata at the Mandir"
  },
  {
    "id": "img-48",
    "title": "Mandir Sacred Goshala",
    "category": "seva",
    "displayCategory": "Seva & Annadhanam",
    "src": "/images/goshala.jpg",
    "url": "/images/goshala.jpg",
    "altText": "Mandir Sacred Goshala",
    "caption": "Dedicated Goshala serving sacred cows with devotion"
  },
  {
    "id": "img-49",
    "title": "Sri Maha Ganapathi Darshan",
    "category": "deities",
    "displayCategory": "Sanctum Deities",
    "src": "/images/vinayagar.jpg",
    "url": "/images/vinayagar.jpg",
    "altText": "Sri Maha Ganapathi Darshan",
    "caption": "Vighnaharta Sri Maha Ganapathi at the sanctum entrance"
  },
  {
    "id": "img-50",
    "title": "Lord Murugan Darshan",
    "category": "deities",
    "displayCategory": "Sanctum Deities",
    "src": "/images/murugar.jpg",
    "url": "/images/murugar.jpg",
    "altText": "Lord Murugan Darshan",
    "caption": "Lord Murugan sanctum blessings"
  },
  {
    "id": "img-51",
    "title": "Lord Shiva Darshan",
    "category": "deities",
    "displayCategory": "Sanctum Deities",
    "src": "/images/sivan.jpg",
    "url": "/images/sivan.jpg",
    "altText": "Lord Shiva Darshan",
    "caption": "Lord Shiva linga sanctum darshan"
  },
  {
    "id": "img-52",
    "title": "Goddess Durga Darshan",
    "category": "deities",
    "displayCategory": "Sanctum Deities",
    "src": "/images/durga.jpg",
    "url": "/images/durga.jpg",
    "altText": "Goddess Durga Darshan",
    "caption": "Divine mother Goddess Durga darshan"
  },
  {
    "id": "img-53",
    "title": "Goddess Sri Maha Varahi Darshan",
    "category": "deities",
    "displayCategory": "Sanctum Deities",
    "src": "/images/varahi.jpg",
    "url": "/images/varahi.jpg",
    "altText": "Goddess Sri Maha Varahi Darshan",
    "caption": "Protective mother Goddess Sri Maha Varahi darshan"
  },
  {
    "id": "img-54",
    "title": "Sri Anjaneyar Darshan",
    "category": "deities",
    "displayCategory": "Sanctum Deities",
    "src": "/images/anjaneyar.jpg",
    "url": "/images/anjaneyar.jpg",
    "altText": "Sri Anjaneyar Darshan",
    "caption": "Devotee supreme Sri Hanuman sanctum darshan"
  },
  {
    "id": "img-55",
    "title": "Sri Radha Krishna Darshan",
    "category": "deities",
    "displayCategory": "Sanctum Deities",
    "src": "/images/radhakrishna.jpg",
    "url": "/images/radhakrishna.jpg",
    "altText": "Sri Radha Krishna Darshan",
    "caption": "Divine lovers Sri Radha Krishna sanctum darshan"
  },
  {
    "id": "img-56",
    "title": "Lord Brahma Darshan",
    "category": "deities",
    "displayCategory": "Sanctum Deities",
    "src": "/images/brahma.jpg",
    "url": "/images/brahma.jpg",
    "altText": "Lord Brahma Darshan",
    "caption": "Creator Lord Brahma sanctum darshan"
  },
  {
    "id": "img-57",
    "title": "Jagadguru Adi Shankaracharya",
    "category": "deities",
    "displayCategory": "Sanctum Deities",
    "src": "/images/shankaracharya.jpg",
    "url": "/images/shankaracharya.jpg",
    "altText": "Jagadguru Adi Shankaracharya",
    "caption": "Jagadguru Sri Adi Shankaracharya darshan"
  },
  {
    "id": "img-58",
    "title": "Sri Sai Baba Darshan Alankaram",
    "category": "alankaram",
    "displayCategory": "Divine Alankaram",
    "src": "/images/saibaba_darshan_alankaram.jpg",
    "url": "/images/saibaba_darshan_alankaram.jpg",
    "altText": "Sri Sai Baba Darshan Alankaram",
    "caption": "Grand temple darshan alankaram"
  },
  {
    "id": "img-59",
    "title": "Sri Sai Baba Homam Darshan",
    "category": "poojas",
    "displayCategory": "Aarti & Poojas",
    "src": "/images/saibaba_homam_darshan.jpg",
    "url": "/images/saibaba_homam_darshan.jpg",
    "altText": "Sri Sai Baba Homam Darshan",
    "caption": "Sacred Homam and Yajna blessings"
  },
  {
    "id": "img-60",
    "title": "Sanctum Divine Atmosphere",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/atmosphere.jpg",
    "url": "/images/atmosphere.jpg",
    "altText": "Sanctum Divine Atmosphere",
    "caption": "Aura and serenity of the temple sanctum"
  },
  {
    "id": "img-61",
    "title": "Divine Mandir Darshan",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/divine.jpg",
    "url": "/images/divine.jpg",
    "altText": "Divine Mandir Darshan",
    "caption": "Holy ambiance of the temple arena"
  },
  {
    "id": "img-62",
    "title": "Sanctum Baba Darshan 1",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/saibaba1.jpg",
    "url": "/images/saibaba1.jpg",
    "altText": "Sanctum Baba Darshan 1",
    "caption": "Bhagavan Sri Sai Baba darshan"
  },
  {
    "id": "img-63",
    "title": "Sanctum Baba Darshan 2",
    "category": "darshan",
    "displayCategory": "Temple Darshan",
    "src": "/images/saibaba2.jpg",
    "url": "/images/saibaba2.jpg",
    "altText": "Sanctum Baba Darshan 2",
    "caption": "Bhagavan Sri Sai Baba blessings"
  },
  {
    "id": "remote-1",
    "title": "Divine Moment 19",
    "category": "temple",
    "displayCategory": "Temple Darshan",
    "src": "https://api.srignanasaibabamandir.in/uploads/1786108053916.jpg",
    "url": "https://api.srignanasaibabamandir.in/uploads/1786108053916.jpg",
    "altText": "Divine Moment 19",
    "caption": "Divine Moment 19"
  },
  {
    "id": "remote-2",
    "title": "Divine Moment 18",
    "category": "temple",
    "displayCategory": "Temple Darshan",
    "src": "https://api.srignanasaibabamandir.in/uploads/1786108054447.jpg",
    "url": "https://api.srignanasaibabamandir.in/uploads/1786108054447.jpg",
    "altText": "Divine Moment 18",
    "caption": "Divine Moment 18"
  },
  {
    "id": "remote-3",
    "title": "Divine Moment 17",
    "category": "temple",
    "displayCategory": "Temple Darshan",
    "src": "https://api.srignanasaibabamandir.in/uploads/1786108054526.jpg",
    "url": "https://api.srignanasaibabamandir.in/uploads/1786108054526.jpg",
    "altText": "Divine Moment 17",
    "caption": "Divine Moment 17"
  },
  {
    "id": "remote-4",
    "title": "Divine Moment 16",
    "category": "temple",
    "displayCategory": "Temple Darshan",
    "src": "https://api.srignanasaibabamandir.in/uploads/1786108054329.jpg",
    "url": "https://api.srignanasaibabamandir.in/uploads/1786108054329.jpg",
    "altText": "Divine Moment 16",
    "caption": "Divine Moment 16"
  },
  {
    "id": "remote-5",
    "title": "Divine Moment 15",
    "category": "temple",
    "displayCategory": "Temple Darshan",
    "src": "https://api.srignanasaibabamandir.in/uploads/1786108054187.jpg",
    "url": "https://api.srignanasaibabamandir.in/uploads/1786108054187.jpg",
    "altText": "Divine Moment 15",
    "caption": "Divine Moment 15"
  },
  {
    "id": "remote-6",
    "title": "Divine Moment 14",
    "category": "temple",
    "displayCategory": "Temple Darshan",
    "src": "https://api.srignanasaibabamandir.in/uploads/1786108054362.jpg",
    "url": "https://api.srignanasaibabamandir.in/uploads/1786108054362.jpg",
    "altText": "Divine Moment 14",
    "caption": "Divine Moment 14"
  },
  {
    "id": "remote-7",
    "title": "Divine Moment 13",
    "category": "temple",
    "displayCategory": "Temple Darshan",
    "src": "https://api.srignanasaibabamandir.in/uploads/1786108054265.jpg",
    "url": "https://api.srignanasaibabamandir.in/uploads/1786108054265.jpg",
    "altText": "Divine Moment 13",
    "caption": "Divine Moment 13"
  },
  {
    "id": "remote-8",
    "title": "Divine Moment 12",
    "category": "temple",
    "displayCategory": "Temple Darshan",
    "src": "https://api.srignanasaibabamandir.in/uploads/1786108055628.jpg",
    "url": "https://api.srignanasaibabamandir.in/uploads/1786108055628.jpg",
    "altText": "Divine Moment 12",
    "caption": "Divine Moment 12"
  },
  {
    "id": "remote-9",
    "title": "Divine Moment 10",
    "category": "temple",
    "displayCategory": "Temple Darshan",
    "src": "https://api.srignanasaibabamandir.in/uploads/1786108054608.jpg",
    "url": "https://api.srignanasaibabamandir.in/uploads/1786108054608.jpg",
    "altText": "Divine Moment 10",
    "caption": "Divine Moment 10"
  },
  {
    "id": "remote-10",
    "title": "Divine Moment 9",
    "category": "temple",
    "displayCategory": "Temple Darshan",
    "src": "https://api.srignanasaibabamandir.in/uploads/1786108056172.jpg",
    "url": "https://api.srignanasaibabamandir.in/uploads/1786108056172.jpg",
    "altText": "Divine Moment 9",
    "caption": "Divine Moment 9"
  },
  {
    "id": "remote-11",
    "title": "Divine Moment 9",
    "category": "temple",
    "displayCategory": "Temple Darshan",
    "src": "https://api.srignanasaibabamandir.in/uploads/1786108055321.jpg",
    "url": "https://api.srignanasaibabamandir.in/uploads/1786108055321.jpg",
    "altText": "Divine Moment 9",
    "caption": "Divine Moment 9"
  },
  {
    "id": "remote-12",
    "title": "Divine Moment 8",
    "category": "temple",
    "displayCategory": "Temple Darshan",
    "src": "https://api.srignanasaibabamandir.in/uploads/1786108054982.jpg",
    "url": "https://api.srignanasaibabamandir.in/uploads/1786108054982.jpg",
    "altText": "Divine Moment 8",
    "caption": "Divine Moment 8"
  },
  {
    "id": "remote-13",
    "title": "Divine Moment 7",
    "category": "temple",
    "displayCategory": "Temple Darshan",
    "src": "https://api.srignanasaibabamandir.in/uploads/1786108056566.jpg",
    "url": "https://api.srignanasaibabamandir.in/uploads/1786108056566.jpg",
    "altText": "Divine Moment 7",
    "caption": "Divine Moment 7"
  },
  {
    "id": "remote-14",
    "title": "Divine Moment 6",
    "category": "temple",
    "displayCategory": "Temple Darshan",
    "src": "https://api.srignanasaibabamandir.in/uploads/1786108055868.jpg",
    "url": "https://api.srignanasaibabamandir.in/uploads/1786108055868.jpg",
    "altText": "Divine Moment 6",
    "caption": "Divine Moment 6"
  },
  {
    "id": "remote-15",
    "title": "Divine Moment 5",
    "category": "temple",
    "displayCategory": "Temple Darshan",
    "src": "https://api.srignanasaibabamandir.in/uploads/1786108057296.jpg",
    "url": "https://api.srignanasaibabamandir.in/uploads/1786108057296.jpg",
    "altText": "Divine Moment 5",
    "caption": "Divine Moment 5"
  },
  {
    "id": "remote-16",
    "title": "Divine Moment 4",
    "category": "temple",
    "displayCategory": "Temple Darshan",
    "src": "https://api.srignanasaibabamandir.in/uploads/1786108056751.jpg",
    "url": "https://api.srignanasaibabamandir.in/uploads/1786108056751.jpg",
    "altText": "Divine Moment 4",
    "caption": "Divine Moment 4"
  },
  {
    "id": "remote-17",
    "title": "Divine Moment 3",
    "category": "temple",
    "displayCategory": "Temple Darshan",
    "src": "https://api.srignanasaibabamandir.in/uploads/1786108056048.jpg",
    "url": "https://api.srignanasaibabamandir.in/uploads/1786108056048.jpg",
    "altText": "Divine Moment 3",
    "caption": "Divine Moment 3"
  },
  {
    "id": "remote-18",
    "title": "Divine Moment 2",
    "category": "temple",
    "displayCategory": "Temple Darshan",
    "src": "https://api.srignanasaibabamandir.in/uploads/1786108057301.jpg",
    "url": "https://api.srignanasaibabamandir.in/uploads/1786108057301.jpg",
    "altText": "Divine Moment 2",
    "caption": "Divine Moment 2"
  },
  {
    "id": "remote-19",
    "title": "Divine Moment 1",
    "category": "temple",
    "displayCategory": "Temple Darshan",
    "src": "https://api.srignanasaibabamandir.in/uploads/1786108056788.jpg",
    "url": "https://api.srignanasaibabamandir.in/uploads/1786108056788.jpg",
    "altText": "Divine Moment 1",
    "caption": "Divine Moment 1"
  }
];

export const GALLERY_CATEGORIES = [
  { key: "all", label: "All Photos", ta: "அனைத்தும்" },
  { key: "darshan", label: "Temple Darshan", ta: "திருக்காட்சி" },
  { key: "alankaram", label: "Divine Alankaram", ta: "அலங்காரம்" },
  { key: "poojas", label: "Aarti & Poojas", ta: "ஆரத்தி & பூஜைகள்" },
  { key: "guruji", label: "Guruji", ta: "குருஜி" },
  { key: "deities", label: "Sanctum Deities", ta: "மூர்த்திகள்" },
  { key: "seva", label: "Seva & Annadhanam", ta: "சேவை & அன்னதானம்" },
];

/**
 * Extracts a normalized unique identifier for an image (filename or clean URL)
 */
export function getPhotoDeduplicationKey(photo) {
  if (!photo) return "";
  const raw = typeof photo === "string" ? photo : (photo.src || photo.url || "");
  if (!raw) return "";
  // Strip origin/protocol to get relative path or clean remote URL
  const cleaned = raw.replace(/^https?:\/\/[^/]+/, "").replace(/^\/+/, "").toLowerCase();
  // If it's a known gallery path e.g. images/gallery/saibaba1.jpg -> gallery/saibaba1.jpg
  if (cleaned.includes("gallery/")) {
    return cleaned.slice(cleaned.indexOf("gallery/"));
  }
  // Otherwise return the base filename or clean path
  return cleaned.split("?")[0].split("#")[0];
}

/**
 * Merges backend photos with local gallery photos without any duplication.
 * If an image already exists in either list, it is not added again.
 */
export function mergeGalleryPhotos(backendPhotos = []) {
  const seenKeys = new Set();
  const merged = [];

  // First include local photos
  for (const p of LOCAL_GALLERY_PHOTOS) {
    const key = getPhotoDeduplicationKey(p);
    if (key && !seenKeys.has(key)) {
      seenKeys.add(key);
      merged.push(p);
    }
  }

  // Then merge any backend photos that don't already exist
  if (Array.isArray(backendPhotos)) {
    for (const bp of backendPhotos) {
      const key = getPhotoDeduplicationKey(bp);
      if (key && !seenKeys.has(key)) {
        seenKeys.add(key);
        merged.push({
          id: bp._id || bp.id || `db-${merged.length + 1}`,
          title: bp.title || "Divine Moment",
          category: bp.category || "darshan",
          displayCategory: bp.displayCategory || (bp.category ? bp.category.charAt(0).toUpperCase() + bp.category.slice(1) : "Temple Darshan"),
          src: bp.src || bp.url,
          url: bp.url || bp.src,
          altText: bp.altText || bp.title || "Sri Gnana Sai Baba Mandir",
          caption: bp.caption || bp.title || "Divine Darshan of Sri Gnana Sai Baba Mandir"
        });
      }
    }
  }

  return merged;
}

/**
 * Safe image URL resolver
 */
export function resolveGalleryImageSrc(src) {
  if (!src) return "/images/placeholder.jpg";
  if (src.startsWith("http://") || src.startsWith("https://") || src.startsWith("data:")) {
    return src;
  }
  return src.startsWith("/") ? src : `/${src}`;
}
